// Filename: public/common.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

// Return a price with a specific format
export function currencyFormat(num) {

    return (
        num
        .toFixed(0) // always two decimal digits
        .replace('.', '') // replace decimal point character with blank
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') //+ ' €'
    ) // use . as a separator
}

// Return a price with a specific format
export function stringToNumber(str) {

    return (
        str
        .replace(/\./g,'') // remove dots
        //.replace(/\,/g,'') // remove comma
    ) 
}

export function allnumeric(inputtxt) {

   	let numbers = /^[0-9]+$/;

	if (inputtxt === undefined || inputtxt === null) {

		return -1
	}

	if (inputtxt !== '') {

		//checks if input data are only numbers
		if(inputtxt.match(numbers)) {
		
			return 1;

		}
		else {

			return -1;
		}
	}
	else {

		//nothing to check
		return 1
	}
} 
